<template>
    <section class="plugin-slider"
             v-bind:class="{ _dark: isDark }"
    >
        <div class="plugin-slider__title">
            <plugin-home-common-title v-bind:text="title"/>
        </div>
        <div class="plugin-slider__container">
<!--            <div></div>-->
            <div class="plugin-slider__content">
                <div class="plugin-slider__content-swiper">
                    <div class="swiper"
                         ref="slider"
                    >
                        <div class="swiper-wrapper">
                            <slot v-bind:is-dark="isDark" />
                        </div>
                    </div>
                    <div class="swiper-pagination"
                         ref="pagination"
                    ></div>
                </div>
            </div>
<!--            <div></div>-->
        </div>
    </section>
</template>

<script>
import utils from '~/utils';

export default {
    name: 'plugin-slider',
    props: {
        title: {
            type: String,
            default: '',
        },
        isDark: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        slider: null,
    }),
    methods: {
        initSwiper() {
            if (!this.slider) {
                this.slider = new window.Swiper(this.$refs.slider, {
                    slidesPerView: 'auto',
                    spaceBetween: 12,
                    snapToSlideEdge: true,
                    mousewheel: {
                        forceToAxis: true,
                    },
                    pagination: {
                        el: this.$refs.pagination,
                        clickable: true,
                    },
                    on: {
                        slideChange: (swiper) => {
                            this.activeIndex = swiper.activeIndex;
                        },
                    },
                });
            }
        },
        waitForSwiper() {
            utils.swiper.waitForSwiper(this.initSwiper);
        },
    },
    mounted() {
        this.waitForSwiper();
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-slider {
    width: 100%;
    &._dark {
        background-color: @color-gray-darker;
        padding: 80px 0;
    }
    &__title {
        .container-landing();
    }
    &__container {
        .container-landing();

        display: grid;
        // grid-template-columns: 1fr minmax(0, @content-max-width) 1fr;
        grid-template-columns: minmax(0, 100%);
        max-width: 100%;
        padding-right: 0 !important;
    }
    &__content {
        // grid-column: ~"2 / 4";
        display: flex;
        gap: 48px;
        &-swiper {
            position: relative;
            width: 100%;
            overflow: hidden;
        }
        /deep/ .swiper-pagination {
            display: none;
        }
    }
    @media @media-md-down {
        &__container {
            padding-right: @landing-padding-sm !important;
        }
        &._dark {
            background-color: @color-gray-darker;
            padding: 40px 0;
        }
        &__content {
            gap: 18px;
            &-swiper {
                padding-bottom: 32px;
            }
            /deep/ .swiper-pagination {
                display: block;
            }
            /deep/ .swiper-pagination-bullet {
                border: 1px solid @color-gray-main;
                background-color: white;
                opacity: 1;
            }
            /deep/ .swiper-pagination-bullet-active {
                background-color: @color-gray-main;
            }
        }
    }
}
</style>
